import React, { useState, useEffect } from 'react';
import { FaTimes } from "react-icons/fa";
import { QRCodeSVG } from 'qrcode.react';

const SocialQRCode = () => {
  const [showQRCode, setShowQRCode] = useState(false);
  // Forçando o domínio de produção
  const siteUrl = 'https://www.hadritech.com.br';
  const qrCodeUrl = `${siteUrl}/redes`;

  // Se estiver na rota /redes, redireciona para a página de redes
  useEffect(() => {
    if (window.location.pathname === '/redes') {
      window.location.href = '/redes';
    }
  }, []);
  
  // Não mostra o modal no carregamento
  useEffect(() => {
    return () => setShowQRCode(false);
  }, []);

  return (
    <div className="w-full">
      <h3 className="text-xl font-semibold text-gray-900 mb-4">
        QR Code para Redes Sociais
      </h3>
      
      <div className="flex flex-col items-center bg-gray-50 p-4 rounded-lg">
        <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-200">
          <QRCodeSVG 
            value={qrCodeUrl}
            size={140}
            level="H"
            includeMargin={true}
            fgColor="#4f46e5"
          />
        </div>
        <p className="mt-3 text-sm text-gray-600 text-center max-w-[180px]">
          Escaneie para acessar nossas redes sociais
        </p>
      </div>
      
      {/* Modal do QR Code */}
      {showQRCode && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl p-6 max-w-sm w-full relative">
            <button 
              onClick={() => setShowQRCode(false)}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
              aria-label="Fechar"
            >
              <FaTimes className="w-6 h-6" />
            </button>
            
            <div className="flex flex-col items-center">
              <div className="p-4 bg-white rounded-lg border-2 border-gray-200 mb-4">
                <QRCodeSVG 
                  value={qrCodeUrl}
                  size={200}
                  level="H"
                  includeMargin={true}
                  fgColor="#2563eb" // Azul do gradiente
                />
              </div>
              
              <div className="text-center">
                <h3 className="text-xl font-bold text-gray-800 mb-2">Escaneie este QR Code</h3>
                <p className="text-sm text-gray-600 mb-4">
                  Aponte a câmera do seu celular para ver todas as nossas redes sociais
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SocialQRCode;
